import { useCallback } from 'react';

import { Path } from 'constants/routing';
import { RootState } from 'store/store';
import { useAppStore } from 'store/store-hooks';

import { findFcPosition } from 'components/app/_helpers/_app.helper';
import { useZoomCb } from 'components/app/_mediator/zoom/use-zoom-cb';
import { useAudioTrackContext } from 'components/app/audio-track/_mediator/audio-track.provider';
import { useFinalcutCb } from 'components/app/finalcuts/_mediator/use-finalcut-cb';
import { SNAPSHOT } from './memory.slice';

export const useMemoryFc = () => {
  const { wsSeekTo } = useAudioTrackContext();
  const { restoreSnapshot, zoomTo } = useZoomCb();
  const { fcSeekTo, fcSelectClip } = useFinalcutCb();
  const store = useAppStore();

  return useCallback(() => {
    const {
      fcStoryBoard,
      sbSnapshot,
      fcSnapshot,
      srSnapshot,
      fcClipsMap,
      fcMarkers,
      cameFrom,
      duration,
      fcCells,
      cells,
    } = selectData(store.getState());

    const restoreFc = () => {
      const snapshot = fcSnapshot ?? SNAPSHOT;
      wsSeekTo(snapshot.cursorTime);
      restoreSnapshot(snapshot);
    };

    switch (cameFrom) {
      case Path.selector: {
        if (!srSnapshot) restoreFc();
        else if (srSnapshot.activeClip) {
          const clipId = fcClipsMap[srSnapshot.activeClip]?.clipId;
          const position = clipId && findFcPosition(clipId, fcStoryBoard);
          if (position) {
            if (fcSnapshot) zoomTo(fcSnapshot.zoom);
            fcSelectClip(position);
          } else restoreFc();
        } else restoreFc();
        return;
      }
      case Path.storyboard: {
        if (!sbSnapshot) return;
        if (!duration || !fcMarkers || !fcCells || !cells) return;
        const { cursorTime, zoom } = sbSnapshot;
        fcSeekTo(cursorTime / duration);
        zoomTo(zoom);
        return;
      }
      default:
        restoreFc();
        return;
    }
  }, []);
};

/* S E L E C T O R */

const selectData = (state: RootState) => {
  const { cameFrom, storyboard: sbSnapshot, finalcut: fcSnapshot, selector: srSnapshot } = state.memory;
  const { fcStoryBoard, fcCells, fcMarkers, fcClipsMap } = state.fc__data;
  const { duration } = state.audio;
  const { cells } = state.editor;
  return {
    fcStoryBoard,
    srSnapshot,
    duration,
    cells,
    fcCells,
    cameFrom,
    fcMarkers,
    sbSnapshot,
    fcSnapshot,
    fcClipsMap,
  };
};
